import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { advancedOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { UnmappedCustomer } from '../../../../store/CustomerMap';

interface UnmappedCustomerGridColumnDefsProps {
  openModal?: (customer: UnmappedCustomer) => void;
}

export const DefaultUnmappedCustomerGridColumnDefs = ({
  openModal = undefined
}: UnmappedCustomerGridColumnDefsProps): GridSingleSelectColDef[] => [
  {
    headerName: 'RPM Customer',
    field: 'customerName',
    flex: 2,
    minWidth: 200,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: advancedOperators(),
    renderCell: (params: GridCellParams<UnmappedCustomer>) => (
      <a
        className="text-indigo"
        title="Open in RPM"
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/Customer.aspx?Item=${params.row.customerId}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.customerName}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'latestRunItems',
    headerName: 'Latest Run Items',
    sortable: false,
    filterable: false,
    flex: 1,
    minWidth: 100,
    type: 'singleSelect',
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams<UnmappedCustomer>) => (
      <a
        className="text-indigo"
        title="View in RPM"
        // eslint-disable-next-line max-len
        href={`${process.env.REACT_APP_RPM_URL}/rpm/Page/CommItems.aspx?ViewID=29&Specific=${params.row.customerId}&YM=${params.row.latestRunYearMonth}`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          View in RPM
          <Icon type="external" />
        </div>
      </a>
    ),
    description: 'Drag to move column'
  },
  {
    field: 'customerId',
    headerName: 'RPM Customer ID',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 100,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'accountCount',
    headerName: 'RPM Accounts',
    sortable: true,
    filterable: true,
    flex: 1,
    minWidth: 100,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: advancedOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    filterable: false,
    flex: 2,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams<UnmappedCustomer>) => (
      <button
        className="text-indigo"
        title="Create New Customer Mapping"
        onClick={(e) => {
          e.preventDefault();
          if (openModal) openModal(params.row);
        }}>
        <div className="flex items-center text-small">
          <Icon
            type="plus"
            className="mr-1"
          />
          New Customer Mapping
        </div>
      </button>
    )
  }
];
